/*  MUI  */
import { Avatar } from '@mui/material';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class CustomTag extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { t, tooltip } = this.props;

        if (tooltip) {
            this.setState({
                tooltip: t(`Tooltips.${tooltip}`)
            });
        }
    }

    renderTag = () => {
        const { t, color, icon, text } = this.props;

        return (
            <div style={{ display: 'flex' }}>
                <Avatar
                    sx={{
                        backgroundColor: color,
                        height: '26px',
                        marginLeft: '1px',
                        marginRight: '6px',
                        width: '26px'
                    }}
                >
                    {icon}
                </Avatar>
                <div style={{ lineHeight: '2' }}>{t(text)}</div>
            </div>
        );
    };

    render() {
        const { tooltip } = this.state;

        if (tooltip) {
            return (
                <DarkTooltip arrow title={<div>{tooltip}</div>}>
                    {this.renderTag()}
                </DarkTooltip>
            );
        }

        return this.renderTag();
    }
}

export default withTranslation()(CustomTag);
